import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 数据大屏
  {
    path: '/',
    name: 'Large',
    component: () => import('../views/index/index.vue')
  },
  {
    path: '/realTime',
    name: 'realTime',
    component: () => import('../views/realTimeData/index.vue')
  },
  {
    path: '/countDown',
    name: 'countDown',
    component: () => import('../views/countDown/index.vue')
  },
  // 404 page must be placed at the end !!!
  {
    path: '/404',
    component: () => import('../views/error-page/404'),
    hidden: true
  }, {
    path: '*',
    redirect: '/404',
    hidden: true
  }]
const router = new VueRouter({
  routes
})

export default router